/** Which rows the next page holds: GAINS Connect lists from the oldest (newer ones next), GAP from the newest. */
export type NextRows = 'newer' | 'older';

const NUMBER = new Intl.NumberFormat('en-US');

const NEXT_ROWS: Record<NextRows | 'more', string> = { newer: 'Newer', older: 'Older', more: 'More' };

/** `2,000`. */
export function formatCount(count: number): string {
  return NUMBER.format(count);
}

/** `1 task`, `2,000 tasks`. */
export function countRows(count: number, row: string, rows: string): string {
  return `${formatCount(count)} ${count === 1 ? row : rows}`;
}

/** `Newer tasks not loaded yet`, `Older alerts not loaded yet`, `More mappings not loaded yet`. */
export function moreRowsText(rows: string, next?: NextRows): string {
  return `${NEXT_ROWS[next ?? 'more']} ${rows} not loaded yet`;
}

/** What a search left empty says of the next page: `2,000 tasks loaded · Newer tasks not loaded yet`. */
export function loadedSummary(count: number, row: string, rows: string, next?: NextRows): string {
  return `${countRows(count, row, rows)} loaded · ${moreRowsText(rows, next)}`;
}
